export class ConfigMaxSetAttrAuthors {
    public id: number;
    public configMaxSetAttrId: number;
    public authorTypeId: number;
    public authorName: String
    public description: String
    public lastUpdate: Date
    public updatedBy: String;
    public status: String;
    public authorType: String;
    public classlabel: String;
    public shape: String;
    public shapeclass: String;
    public statusId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/configmaxsetattrauthors.ts